// src/services/sewaKendaraanService.js
import api from './api';

export const sewaKendaraanService = {
    // ============ PUBLIC ============
    getPublic: async () => {
        try {
            const response = await api.get('/sewa-kendaraan/public');
            return { success: true, data: response.data?.data || [] };
        } catch { return { success: false, message: 'Gagal ambil data' }; }
    },
    submit: async (formData) => {
        try {
            const response = await api.post('/sewa-kendaraan/submit', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (e) {
            return {
                success: false,
                message: e.response?.data?.message || 'Gagal mengirim',
                errors: e.response?.data?.errors,
            };
        }
    },

    // ============ ADMIN — Kendaraan ============
    getList: async () => {
        try {
            const response = await api.get('/sewa-kendaraan-admin');
            return { success: true, data: response.data?.data || [] };
        } catch { return { success: false }; }
    },
    create: async (data) => {
        try {
            const isFormData = data instanceof FormData;
            const response = await api.post('/sewa-kendaraan-admin', data, {
                headers: isFormData
                    ? { 'Content-Type': 'multipart/form-data' }
                    : { 'Content-Type': 'application/json' },
            });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (e) { return { success: false, message: e.response?.data?.message }; }
    },
    update: async (id, data) => {
        try {
            const isFormData = data instanceof FormData;
            const response = await api.post(`/sewa-kendaraan-admin/${id}`, data, {
                headers: isFormData
                    ? { 'Content-Type': 'multipart/form-data' }
                    : { 'Content-Type': 'application/json' },
            });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (e) { return { success: false, message: e.response?.data?.message }; }
    },
    delete: async (id) => {
        try { await api.delete(`/sewa-kendaraan-admin/${id}`); return { success: true }; }
        catch { return { success: false }; }
    },
    toggle: async (id) => {
        try {
            const response = await api.post(`/sewa-kendaraan-admin/${id}/toggle`);
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch { return { success: false }; }
    },

    // ============ ADMIN — Submissions ============
    getSubmissions: async (params = {}) => {
        try {
            const response = await api.get('/sewa-kendaraan-submissions', { params });
            return { success: true, data: response.data?.data };
        } catch { return { success: false }; }
    },
    getSubmissionStatistics: async () => {
        try {
            const response = await api.get('/sewa-kendaraan-submissions/statistics');
            return { success: true, data: response.data?.data };
        } catch { return { success: false }; }
    },
    getSubmissionDetail: async (id) => {
        try {
            const response = await api.get(`/sewa-kendaraan-submissions/${id}`);
            return { success: true, data: response.data?.data };
        } catch { return { success: false }; }
    },
    updateSubmissionStatus: async (id, payload) => {
        try {
            const response = await api.post(`/sewa-kendaraan-submissions/${id}/status`, payload);
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (e) { return { success: false, message: e.response?.data?.message }; }
    },
    confirmPayment: async (id, formData) => {
        try {
            const response = await api.post(`/sewa-kendaraan-submissions/${id}/confirm-payment`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (e) { return { success: false, message: e.response?.data?.message }; }
    },
    deleteSubmission: async (id) => {
        try { await api.delete(`/sewa-kendaraan-submissions/${id}`); return { success: true }; }
        catch { return { success: false }; }
    },
};